import FilterDateLast12Months from "./FilterDateLast12Months";
const FilterPaidOffDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateLast12Months
      source="limitPaidOffDate"
      label="Paid-Off Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterPaidOffDate;
